module.exports = __webpack_public_path__ + "static/img/qi_8.f4bb44a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qi_8.jpg
// module id = ZXgO
// module chunks = 1